import { Component, computed, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { RouterLink } from '@angular/router';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { InputText } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { Select } from 'primeng/select';
import { OrganisationDatasource } from '@features/organisation/organisation.datasource';
import { BrugerDatasource } from '@features/brugere/bruger.datasource';
import { RolleDatasource } from '@features/roller/rolle.datasource';
import { BrugerSearchParams } from '@features/brugere/bruger-search-params.model';

@Component({
  selector: 'app-brugere-grid',
  imports: [
    TableModule,
    DatePipe,
    RouterLink,
    TableRowDirective,
    ButtonModule,
    ToolbarModule,
    InputText,
    FormsModule,
    IconField,
    InputIcon,
    Select
  ],
  templateUrl: './brugere-grid.component.html',
  styleUrl: './brugere-grid.component.css'
})
export class BrugereGridComponent {
  brugerDatasource = inject(BrugerDatasource);
  rolleDatasource = inject(RolleDatasource);
  roller = computed(() => {
    const apiResponse = this.rolleDatasource.data.value();
    if (apiResponse) {
      return apiResponse.data;
    }
    return [];
  });
  organisationDatasource = inject(OrganisationDatasource);
  brugere = computed(
    () => {
      const apiResponse = this.brugerDatasource.data.value();
      if (apiResponse) {
        return apiResponse.data;
      } else {
        return [];
      }
    }
  );
  searchText = signal<string>('');
  searchRolleId = signal<number | undefined>(undefined);
  searchOrganisationId = signal<number | undefined>(undefined);

  async onSearch() {
    this.brugerDatasource.searchParams.set({
      text: this.searchText(),
      rolleId: this.searchRolleId(),
      organisationId: this.searchOrganisationId()
    } as BrugerSearchParams);
  }
}
